import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import { PlatformsModel } from 'Pages/advertisement/models'
import { Callback } from 'Src/types/utilTypes'

export type PlatformState = {
	requestParams: RequestParams
	platforms_list: ResponseCatalog<PlatformsModel>
}

export const platformInitialState: PlatformState = {
	requestParams: new RequestParams(),
	platforms_list: new ResponseCatalog<PlatformsModel>(),
}

export namespace platformNS {
	export type getPlatformsList = PayloadAction<{
		params: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type setPlatformsList = PayloadAction<ResponseCatalog<PlatformsModel>>
	export type setRequestParams = PayloadAction<RequestParams>
}

export const platformSlice = createSlice({
	name: 'platform',
	initialState: platformInitialState,
	reducers: {
		setRequestParams: (state, action: platformNS.setRequestParams) => {
			state.requestParams = action.payload
		},
		clearAllPlatform: (state) => {
			state.platforms_list = new ResponseCatalog<PlatformsModel>()
			state.requestParams = new RequestParams()
		},

		getPlatformsList: (state, action: platformNS.getPlatformsList) => {},
		setPlatformsList: (state, action: platformNS.setPlatformsList) => {
			state.platforms_list = action.payload
		},
	},
})
